module.exports = __webpack_public_path__ + "img/SketchPnga772c7513e43688a65463086833268af393acee7e6b2335678e893a567d177f8.908852dd.png";